import { render, staticRenderFns } from "./Erc20TransationList.vue?vue&type=template&id=0d613b80&"
import script from "./Erc20TransationList.vue?vue&type=script&lang=js&"
export * from "./Erc20TransationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports